import $foreign from "./foreign.cjs";
var unTranslationKey = $foreign.unTranslationKey;
var unsafeMakeTranslationKeysProxy = $foreign.unsafeMakeTranslationKeysProxy;
export { unTranslationKey, unsafeMakeTranslationKeysProxy };
